import { Request } from '../../../../httpClient/serverApi/requests/Request';
import { IResult } from '../../../../httpClient/serverApi/types/IResponse';

export interface IsMfaEnforcedOnThisSiteViewModel extends IResult {
  isMfaEnforced: boolean;
}

export class IsMfaEnforcedOnThisSiteRequest extends Request<{}, IsMfaEnforcedOnThisSiteViewModel> {
  constructor() {
    super('isMfaEnforcedOnThisSite', {});
  }
}
